import request from '../utils/request'

export function getCode(data) { // 公众号登录获取微信code
  return request({
    url: '/api/wechat/getCode',
    method: 'POST',
    data
  })
}

export function getOpenId(data) { // 获取公众号openid
  return request({
    url: '/api/wechat/getOpenid',
    method: 'POST',
    data
  })
}

export function getWxConfig(data) { // 获取公众号权限验证参数
  return request({
    url: '/api/wechat/getWxConfig',
    method: 'POST',
    data
  })
}
